module.exports = __webpack_public_path__ + "img/fail2.c1612b8a.gif";